
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { WebsiteNotificationRecordRequest, WebsiteNotificationRecordResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<WebsiteNotificationRecordResponse, WebsiteNotificationRecordResponse>) => response?.data;
const getError = (response?: SWRResponse<WebsiteNotificationRecordResponse, WebsiteNotificationRecordResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<WebsiteNotificationRecordResponse, WebsiteNotificationRecordResponse>) => ({});

const useGetWebsiteNotificationRecord = (query?: Partial<WebsiteNotificationRecordRequest>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new WebsiteNotificationRecordRequest(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetWebsiteNotificationRecord;